// Liste centralisée des types de capteurs et d'actionneurs supportés par Sagrada.
// Source unique pour les modals (Add/Edit Noeud), les listes, la doc IoT.

export const TYPES_CAPTEUR = [
  "Capteur Température",
  "Capteur Humidité",
  "Capteur Humidité Sol",
  "Capteur CO2",
  "Capteur Pression",
  "Capteur Qualité Air",
  "Capteur Lumière",
  "Capteur UV",
  "Capteur Niveau Eau",
  "Capteur Débit Eau",
  "Capteur pH",
  "Capteur Conductivité",
  "Capteur Salinité",
  "Capteur Mouvement",
  "Capteur Présence",
  "Capteur Ouverture",
  "Capteur Fuite",
  "Capteur Fumée",
  "Capteur Gaz",
  "Capteur Vibration",
  "Capteur Bruit",
  "Capteur Tension",
  "Capteur Courant",
  "Capteur Énergie",
  "Capteur Distance",
  "Capteur GPS",
  "Compteur Impulsions",
  "Caméra IP",
];

export const TYPES_ACTIONNEUR = [
  "Vanne",
  "Pompe",
  "Moteur",
  "Relais",
  "Lumière",
  "Éclairage",
  "Climatisation",
  "Ventilation",
  "Ventilateur",
  "Thermostat",
  "Chauffage",
  "Volet",
  "Serrure",
  "Verrou",
  "Sirène",
  "Buzzer",
  "Diffuseur",
  "Affichage",
];

export const TYPES_BY_CATEGORIE = {
  Capteur: TYPES_CAPTEUR,
  Actionneur: TYPES_ACTIONNEUR,
};
